import {SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const CoinsHistoryHeaderSkeleton = () => {
  return (
    <Wrapper>
      <RowSkeleton />
      <RowSkeleton />
    </Wrapper>
  );
};

const DarkSkeletonBlock = styled(SkeletonBlock)`
  background-image: linear-gradient(to right, #474747, #2a2a2d 47%, #474747);
`;

const RowSkeleton = styled(DarkSkeletonBlock)`
  height: 1rem;
  width: 80%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
`;
